import type { CSSProperties } from 'react'
import { type ClassValue, clsx } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

/**
 * 處理自訂 key 被覆蓋問題
 * @see https://github.com/dcastil/tailwind-merge/issues/276
 */
const customTwMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [{ text: [(value: string) => Number(value) <= 100] }], // text-1 ~ text-100
      rounded: [{ rounded: [(value: string) => Number(value) <= 200] }], // rounded-1 ~ rounded-200
    },
  },
})

/** Variable 單色轉 Content */
export const getVariableContent = (colors: string, container?: ':root' | string) => {
  if (typeof colors !== 'object' || colors === null) {
    // @ts-ignore
    colors = {}
    console.error('colors is not object')
  }
  const content = Object.keys(colors)
    .map((key) => `${key.replace(/\//, '-')}: ${colors[key as keyof typeof colors]};`)
    .join('\n')
  if (container) return `${container} { ${content} }`.replace(/\n/g, '')
  return content.replace(/\n/g, '')
}

/** Tailwind CSS key 合併過濾 */
export function cn(...inputs: ClassValue[]) {
  return customTwMerge(clsx(inputs))
}

/** Background Style */
export function bg(img?: string, style?: CSSProperties) {
  if (typeof img === 'string' && img.startsWith('linear-gradient')) return { background: img.replace(/;$/, ''), ...style }

  if (!img) return style
  return {
    backgroundImage: `url(${img})`,
    ...style,
  }
}

/** Get Tailwind Dynamic Value */
export function tw(value: string) {
  return value.replace(/\s/g, '_')
}
